import { render } from "./ToppingsWidget.vue?vue&type=template&id=218520a5"
import script from "./ToppingsWidget.vue?vue&type=script&lang=js"
export * from "./ToppingsWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__